export const exhaustiveSwitchGuard = (action: never) => {
  throw new Error(`${JSON.stringify(action)} action is not supported`);
};
